import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const PaperClipIcon = ({ className, fill = "#2e2e2e" }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        d="M10 0C4.47251 0 0 4.47325 0 10C0 15.5275 4.47325 20 10 20C15.5275 20 20 15.5267 20 10C20 4.47251 15.5267 0 10 0ZM15.235 11.3488L11.0755 15.5082C10.8458 15.7379 10.4734 15.738 10.2436 15.5082C10.0139 15.2785 10.0139 14.906 10.2436 14.6763L14.4031 10.5169C15.5525 9.36753 15.5527 7.50698 14.4031 6.35745C13.2537 5.20808 11.3932 5.20788 10.2436 6.35745L5.25231 11.3488C4.56427 12.0369 4.56427 13.1564 5.25231 13.8445C5.942 14.534 7.05824 14.5342 7.748 13.8445L12.7393 8.85314C12.9687 8.62376 12.9687 8.25059 12.7393 8.02122C12.51 7.79188 12.1369 7.79184 11.9075 8.02126L9.41177 10.5169C9.18208 10.7465 8.80961 10.7465 8.57988 10.5169C8.35016 10.2872 8.35016 9.91471 8.57988 9.68498L11.0756 7.18929C11.7636 6.50129 12.8832 6.50122 13.5712 7.18929C14.2593 7.87737 14.2593 8.9969 13.5712 9.68498L8.57984 14.6763C7.43055 15.8257 5.56992 15.8259 4.42043 14.6763C3.27098 13.5269 3.27086 11.6665 4.42043 10.5169L9.41177 5.52553C11.0209 3.91635 13.6256 3.91612 15.235 5.52553C16.8405 7.13102 16.8405 9.74329 15.235 11.3488Z"
        fill={fill}
      />
    </svg>
  );
};

export default PaperClipIcon;
